import type { Boss } from './types'

export const AWOKEN_FANG_BOSS = 'crowned-king-awoken'

// Keep logical poses/timing intact. Each alternative inherits its source pose's
// scale and ground anchors. Redesigned rest faces have their own glow anchors.
export const AWOKEN_FANG_ATTACK_ART: Readonly<Record<string, string>> = {
  // 2026-10-06: 7・8・19番は顔を起こしてから歯を描き直した版 (ユーザーが選択ページで ◎ にした R2/R2/R1)。
  //   口の外は 0917 と同じ寸法・同じ alpha なので、顔と口の位置の値は旧のまま使える。旧は ?awokenFangs=0917 で見比べる。
  extend_coil: 'extend_coil_fangs_1006',
  frenzy_open: 'frenzy_open_fangs_0917',
  frenzy_bite2: 'frenzy_bite2_fangs_1006',
  // 2026-10-07: 9番(rush_windup)・18番(swoop_bite)も顔を起こして描き直した版へ (ユーザーが選択ページで ◎ にした S3 / S6)。
  rush_windup: 'rush_windup_fangs_1007',
  swoop_bite_0920: 'swoop_bite_fangs_1007',
  // 2026-10-07: 10番(rush_lunge)は番号付きの描き込みで描いた版から奥の①だけ縮めた版 (ユーザー「１０－１２でいいや」)。
  rush_lunge: 'rush_lunge_fangs_1007',
  rampage_leap: 'rampage_leap_fangs_0917',
  // 2026-10-07: 17番(rampage_slam)は番号付きの描き込みで、①③を手前として大きく描き直した版 (ユーザー「17-12」)。
  rampage_slam: 'rampage_slam_fangs_1007',
  // 2026-10-07: 16番(roar_up)は番号付きの描き込み＋「手前②④を大きく・奥①③を小さく」で描き直した版 (ユーザー「１６－５」)。
  roar_up: 'roar_up_fangs_1007',
  // 2026-10-07: 11番(chase_coil・噛みの合間の向き直り)は牙なし下地＋描き込みで描き直した版 (ユーザーが選択ページで ◎ にした K4)。
  //   口の外は旧と同じ寸法。顔の外へはみ出す旧の牙は消し、新しい①③がはみ出す。追い(12番)は時間表が chase_coil_fangs_0924 を指すので別 (下の AWOKEN_CHASE_FANGS_*)。
  chase_coil: 'chase_coil_fangs_1007',
  // 2026-10-05: 処刑の2枚は口の中だけ描き直した版 (ユーザーの描き込みどおりに歯を置いた G1 案。
  //   ユーザー「14番は G1 で決まり」「15番 G1」「ゲームで動かして気にならなければ一旦進めたほうが良さそう」)。
  //   口の外は旧 *_0917 と1画素も違わない (同じ寸法・同じ alpha) ので、顔と口の位置の値は旧のまま使える。
  exec_windup: 'exec_windup_fangs_1005',
  exec_bite: 'exec_bite_fangs_1005',
  slam_landing_0920: 'slam_landing_fangs_1006',
}
// 旧の 7・8・19番 (2026-09-17 / 09-20)。DEV の ?awokenFangs=0917 で見比べられる。
export const AWOKEN_FANG_PREVIOUS_ATTACK_ART: Readonly<Record<string, string>> = {
  extend_coil: 'extend_coil_fangs_0917',
  frenzy_bite2: 'frenzy_bite2_fangs_0917',
  slam_landing_0920: 'slam_landing_0920',
  rush_windup: 'rush_windup_fangs_0917',
  swoop_bite_0920: 'swoop_bite_0920',
  roar_up: 'roar_up_fangs_0917',
  rampage_slam: 'rampage_slam_fangs_0917',
  rush_lunge: 'rush_lunge_fangs_0917',
  chase_coil: 'chase_coil',
}
// 突進の構え(9番)は大暴れ稽古の時間表が牙ありの旧キーを直接指す。旧キーは新しい絵へ読み替える。
export const AWOKEN_RUSH_WINDUP_FANGS_PREVIOUS = 'rush_windup_fangs_0917'
// 旧の処刑の牙 (2026-09-17)。DEV の ?awokenExecFangs=0917 で見比べられる。
export const AWOKEN_FANG_EXEC_PREVIOUS_ART: Readonly<Record<string, string>> = {
  exec_windup: 'exec_windup_fangs_0917',
  exec_bite: 'exec_bite_fangs_0917',
}
export const AWOKEN_FANG_PREVIOUS_REST_ART: Readonly<Record<string, string>> = {
  bite_step: 'bite_step_rest_0917',
  bite_follow: 'bite_follow_rest_0917',
  bite_recover: 'bite_recover_rest_0917',
  rush_overextend: 'rush_overextend_rest_0917',
  dash_form: 'dash_form_rest_0917',
}
export const AWOKEN_FANG_REST_ART: Readonly<Record<string, string>> = {
  ...AWOKEN_FANG_PREVIOUS_REST_ART,
  bite_step: 'bite_step_rest_idle_0917',
  bite_follow: 'bite_follow_rest_idle_0917',
  bite_recover: 'bite_recover_rest_idle_0917',
  // 19番は牙ありの絵そのものが技の絵なので、戻りの区間でも新しい歯の版に揃える。
  slam_landing_0920: 'slam_landing_fangs_1006',
  swoop_bite_0920: 'swoop_bite_fangs_1007',
}
// 大暴れ第5案の移動中だけ使う「牙を伏せた」姿 (2026-09-20)。
//   この3つは 2026-09-12 に牙ありの絵へ差し替えてあり (`SPRITE_FILE_OVERRIDE`)、キーだけでは牙なしに戻せない。
//   そこで牙なしの原画 (`wall_kick.png` など) を別キーとして読み込む。絵は増えない (同じファイルを指す)。
export const AWOKEN_FANG_TRAVEL_ART: Readonly<Record<string, string>> = {
  wall_kick: 'wall_kick_plain_0920',
  dash_crouch: 'dash_crouch_plain_0920',
  dash_form: 'dash_form_plain_0920',
}
// Adopted chase art is selected by its timeline; other attacks using chase_coil keep their art.
export const AWOKEN_FANG_STUDY_ART: Readonly<Record<string, string>> = {
  chase_coil: 'chase_coil_fangs_0924',
}
// 12番(追い噛みの構え・chase_coil_fangs_0924)は 10-01 に口の中だけ描き直した版 (10-05 ユーザー「直った」・
//   10-07「入れる」)。時間表は旧キーを直接指すので、旧キーを新しい絵へ読み替える。旧は DEV の ?awokenFangs=0917。
//   口の外は旧と同じ (RGB は1画素も違わない・alpha は口の中だけ違う)。
export const AWOKEN_CHASE_FANGS_PREVIOUS = 'chase_coil_fangs_0924'
export const AWOKEN_CHASE_FANGS_REDRAWN = 'chase_coil_fangs_1001'
const SOURCE_POSE: Readonly<Record<string, string>> = Object.fromEntries(
  [...Object.entries(AWOKEN_FANG_ATTACK_ART), ...Object.entries(AWOKEN_FANG_PREVIOUS_REST_ART),
    ...Object.entries(AWOKEN_FANG_REST_ART), ...Object.entries(AWOKEN_FANG_TRAVEL_ART),
    ...Object.entries(AWOKEN_FANG_STUDY_ART), ['chase_coil', AWOKEN_CHASE_FANGS_REDRAWN],
    ...Object.entries(AWOKEN_FANG_EXEC_PREVIOUS_ART),
    ...Object.entries(AWOKEN_FANG_PREVIOUS_ATTACK_ART)]
    .filter(([base, image]) => base !== image)
    .map(([base, image]) => [image, base]),
)
export const AWOKEN_FANG_EXTRA_IMAGES = Object.keys(SOURCE_POSE)

export function awokenFangSourcePose(bossId: string, image: string): string {
  return bossId === AWOKEN_FANG_BOSS ? (SOURCE_POSE[image] ?? image) : image
}

// beatGap is an inter-attack string gap, not a punish window. It deliberately
// samples recovery@0 in the timeline, so checking that sampled phase is wrong.
export function awokenFangPose(boss: Boss, image: string): string {
  if (boss.id !== AWOKEN_FANG_BOSS || boss.hp <= 0 || !boss.currentAttack) return image
  if (import.meta.env.DEV && typeof window !== 'undefined'
    && new URLSearchParams(window.location.search).get('awokenFangs') === 'old') return image
  if (image === AWOKEN_RUSH_WINDUP_FANGS_PREVIOUS
    && !(import.meta.env.DEV && typeof window !== 'undefined'
      && new URLSearchParams(window.location.search).get('awokenFangs') === '0917')) {
    image = AWOKEN_FANG_ATTACK_ART.rush_windup!
  }
  if (image === AWOKEN_CHASE_FANGS_PREVIOUS
    && !(import.meta.env.DEV && typeof window !== 'undefined'
      && new URLSearchParams(window.location.search).get('awokenFangs') === '0917')) {
    image = AWOKEN_CHASE_FANGS_REDRAWN
  }
  if (boss.state === 'recovery') {
    // bite_recover の絵 (bite_recover_rest_idle_0917) はどの技にも出さない (2026-10-01 ユーザー
    //   「一番最後の絵が情けない顔みたいだからどの技にも入れないでほしい」)。
    //   その区間は1つ前の牙なしの絵 (bite_follow) のまま待機へ戻る。旧は連噛み2技だけがこうだった。
    if (image === 'bite_recover') image = 'bite_follow'
    const previous = import.meta.env.DEV && typeof window !== 'undefined'
      && new URLSearchParams(window.location.search).get('awokenRest') === 'previous'
    return (previous ? AWOKEN_FANG_PREVIOUS_REST_ART : AWOKEN_FANG_REST_ART)[image] ?? image
  }
  if (boss.state === 'telegraph' || boss.state === 'active'
    || boss.state === 'comboGap' || boss.state === 'beatGap') {
    // 大暴れ第5案だけ、1つの技の中に移動と攻撃が交互に入る (2026-09-20 ユーザー
    //   「攻撃中や連が途切れてない時は牙出してね／移動は出さない」)。跳び・壁しがみつき・
    //   壁蹴り・跳ぶ前の屈みは移動なので牙を伏せ、噛みと床技だけ牙を見せる。
    if (boss.currentAttack.id === RAMPAGE_V5_ATTACK_ID && RAMPAGE_V5_TRAVEL_IMAGES.has(image)) {
      return AWOKEN_FANG_TRAVEL_ART[image] ?? image
    }
    if (import.meta.env.DEV && typeof window !== 'undefined' && AWOKEN_FANG_EXEC_PREVIOUS_ART[image]
      && new URLSearchParams(window.location.search).get('awokenExecFangs') === '0917') {
      return AWOKEN_FANG_EXEC_PREVIOUS_ART[image]!
    }
    if (import.meta.env.DEV && typeof window !== 'undefined' && AWOKEN_FANG_PREVIOUS_ATTACK_ART[image]
      && new URLSearchParams(window.location.search).get('awokenFangs') === '0917') {
      return AWOKEN_FANG_PREVIOUS_ATTACK_ART[image]!
    }
    return AWOKEN_FANG_ATTACK_ART[image] ?? image
  }
  return image
}

export const RAMPAGE_V5_ATTACK_ID = 'rampageV5'
export const RAMPAGE_V5_TRAVEL_IMAGES: ReadonlySet<string> = new Set([
  'rampage_leap', 'wall_kick', 'rush_lunge', 'dash_form', 'dash_crouch',
])
